import React from 'react';
import { logoutUser } from '@/redux/user/userActions';
import { removeStorage } from '@/utils/auth-utils';
import { isJsrStorageKey } from '@/utils/constants';
import { setStorageObject } from '@/utils/global';
import * as Sentry from '@sentry/react';
import Gleap from 'gleap';
import Cookies from 'js-cookie';
import { NotificationManager } from 'react-notifications';
import { useNavigate } from 'react-router-dom';

import ButtonComponent from '@/components/common-components/ButtonComponent/ButtonComponent';
import IconContainer from '@/components/common-components/FtuxComponent/IconContainer';
import ModalComponent from '@/components/common-components/ModalComponent/ModalComponent';

export default function TrialOverModal({ show }: { show: boolean }) {
  const navigate = useNavigate();

  if (show) {
    Gleap.startConversation();
  }

  return (
    <ModalComponent
      show={show}
      width={480}
      onClose={() => {}}
      outsideClickClose={false}
      style={{ padding: '32px' }}
      bodyStyle={{ padding: 0 }}>
      <div className="warning-modal modal-main-content">
        <IconContainer icon="⏰" bgColor="rgba(229, 142, 9, 0.10)" />
        <h2 style={{ marginBottom: '24px' }}>Trial Time Ran Out!</h2>
        <p style={{ paddingBottom: '24px' }}>Your trial is over. We'd love to officially onboard you on SARAL soon.</p>
        <p style={{ paddingBottom: '24px' }}>
          If you need to chat more or have questions, please reach out to your SARAL sales guide over email or reach out
          to us in the support chat below.
        </p>
        <div className="modal-footer-button-container">
          <ButtonComponent
            onClick={() => {
              Gleap.setTicketAttribute('Intent', 'My Trial is over! Please help me with account access');
            }}
            variant="secondary"
            style={{ padding: '10px 18px' }}>
            Contact Support
          </ButtonComponent>
        </div>
      </div>
    </ModalComponent>
  );
}
